import { useTranslation } from 'react-i18next';
import { AdsChunkSize } from './AdsWithInfiniteScroll.types';
import { AdsSection } from '@/components/AdsSection/AdsSection';

export const VipAndLatestAdsSkeletonLoader = () => {
  const { t } = useTranslation();

  return (
    <>
      <AdsSection title={t('pages.home.vip_ads')} adsLoading hasPaddingTop />
      <AdsSection
        title={t('pages.ads.ads')}
        adsLoading
        chunkSize={AdsChunkSize.Large}
      />
    </>
  );
};
